import React from 'react';
import { View, ViewStyle } from 'react-native';
import PageFooter from './PageFooter';

/** ContentContainer - constrains content width for consistent layout. */
interface ContentContainerProps {
  readonly children: React.ReactNode;
  readonly role?: 'auth' | 'user' | 'owner' | 'admin';
  readonly maxWidth?: number;
  readonly style?: ViewStyle;
  /**
   * Render the trademark PageFooter after the children (default true).
   * Turn off where the container wraps the scroll view instead of living
   * inside it (the screen then renders <PageFooter/> at its scroll end),
   * or where a shell already added one (RootNavigator's auth wrapper).
   */
  readonly footer?: boolean;
}

const ROLE_WIDTHS: Record<string, number> = { auth: 420, user: 480, owner: 560, admin: 1200 };

export default function ContentContainer({ children, role, maxWidth, style, footer = true }: ContentContainerProps) {
  const resolvedMax = maxWidth ?? (role ? ROLE_WIDTHS[role] : 480);

  return (
    <View style={[{ flex: 1, maxWidth: resolvedMax, marginHorizontal: 'auto', width: '100%' } as ViewStyle, style]}>
      {children}
      {footer && <PageFooter />}
    </View>
  );
}
